import Vue from "vue";
import "./plugins/element.js";
import App from "./view/App.vue";
import "./assets/style/global.scss";
import "./assets/style/mobile.scss";
import SvgIcon from "./components/Svg/index.vue";
import router from './router';


import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
import 'swiper/swiper.css'
Vue.use(VueAwesomeSwiper)

// 导入svg
Vue.component("svg-icon", SvgIcon);

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);

const req = require.context("@/assets/img/svg", true, /\.svg$/);
requireAll(req);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

// 媒体本地缓存 Service Worker（方案 V1.3，仅北京）：
// 仅生产构建注册，npm run dev 完全不注册（不影响 HMR 调试）；
// updateViaCache:'none' 使 sw.js 更新检查一律绕过 HTTP 缓存（现代 Chrome 68+ 默认已如此）
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(err => {
    console.warn('[媒体缓存] Service Worker 注册失败:', err);
  });
}
